import { BaseState, Filter, INITIAL_BASE_STATE, Pagination } from '@iot-platform/models/common';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { UserApiKeysActions } from '../actions';
import { UserApiKey } from '@iot-platform/models/i4b';

export type State = BaseState<UserApiKey, Pagination, Filter>;

export const adapter: EntityAdapter<UserApiKey> = createEntityAdapter<UserApiKey>({
  selectId: /* istanbul ignore next */ (entity: UserApiKey) => entity.id,
  sortComparer: false
});

export const initialState: State = adapter.getInitialState({
  ...INITIAL_BASE_STATE,
  pagination: { currentPage: 0, hasMore: false, limit: 100, maxPage: 0, total: 0 }
});

export const userApiKeysFeature = createFeature({
  name: 'userApiKeys',
  reducer: createReducer(
    initialState,
    on(UserApiKeysActions.loadUserApiKeys, (state: State): State => ({ ...state, loading: true, loaded: false })),
    on(UserApiKeysActions.loadUserApiKeysSuccess, (state: State, { response }): State => adapter.setAll(response, { ...state, loaded: true, loading: false })),
    on(UserApiKeysActions.loadUserApiKeysFailure, (state: State): State => ({ ...state, loaded: false, loading: false })),
    on(
      UserApiKeysActions.createUserApiKeySuccess,
      UserApiKeysActions.renewUserApiKeySuccess,
      (state: State, { response }): State => adapter.addOne(response, { ...state })
    ),
    on(
      UserApiKeysActions.editUserApiKeySuccess,
      UserApiKeysActions.enableUserApiKeySuccess,
      UserApiKeysActions.disableUserApiKeySuccess,
      UserApiKeysActions.manageUserApiKeyUsagePlanSuccess,
      (state: State, { response }): State => adapter.updateOne({ id: response.id, changes: response }, { ...state })
    ),
    on(UserApiKeysActions.deleteUserApiKeySuccess, (state: State, { response }): State => adapter.removeOne(response.id, { ...state }))
  )
});
